import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Container, Loader, Table, Input } from '@itds/elements/index.js';
import H1 from '@brokerage/components/H1';
import DOMPurify from 'dompurify';
import { debounce } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMobileApps,
  setCurrentPage,
  setSearchTerm,
  clearCache
} from '@redux/brokerageSlices/mobileAppsSlice';

const MobileAppsList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { mobileApps, pagination, loading, error, currentPage, searchTerm } = useSelector(
    state => state.mobileApps
  );

  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);

  useEffect(() => {
    dispatch(fetchMobileApps({ page: currentPage, search_term: searchTerm }));
  }, [dispatch, currentPage, searchTerm]);

  const debouncedSetSearchTerm = useMemo(
    () =>
      debounce(value => {
        dispatch(setSearchTerm(value));
      }, 500),
    [dispatch]
  );

  const handleSearchChange = e => {
    let value = e.target.value.trimStart();

    value = DOMPurify.sanitize(value);
    setLocalSearchTerm(value);
    debouncedSetSearchTerm(value);
  };

  const handleSearchKeyDown = e => {
    if (e.key === 'Enter') {
      debouncedSetSearchTerm.cancel();
      dispatch(setSearchTerm(localSearchTerm));
      dispatch(setCurrentPage(1));
      dispatch(clearCache());
    }
  };

  const handlePageChange = newPage => {
    window.scrollTo(0, 0);
    dispatch(setCurrentPage(newPage));
    dispatch(fetchMobileApps({ page: newPage, search_term: searchTerm }));
  };

  return (
    <Container>
      {error && <Alert type='error'>{error}</Alert>}

      <H1>Mobile Apps</H1>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 30 }}>
        <Input
          onChange={handleSearchChange}
          onKeyDown={handleSearchKeyDown}
          placeholder='Search mobile apps...'
          style={{ width: 300 }}
          value={localSearchTerm}
        />
      </div>

      {loading ? (
        <Loader />
      ) : (
        <Table
          apiPagination={{ ...pagination, current_page: currentPage, onClick: handlePageChange }}
          columns={[
            { id: 'name', label: 'Name' },
            {
              id: 'latest_build_version',
              label: 'Latest Build Version',
              render: row => row.latest_build_version || 'Never Built',
              style: { textAlign: 'left' }
            }
          ]}
          data={mobileApps}
          onRowClick={row_object => navigate(`${row_object.guid}/builds`)}
        />
      )}
    </Container>
  );
};

export default MobileAppsList;
